import React from "react"
import { ThemeProvider } from "styled-components"
import ScrollableGridComponent from "components/scrollable-grid"
import SectionHeading from "components/section-heading"
import {
  Container,
  PreHeading,
  HeadingRow,
  Body,
  DesktopWrapper,
  MobileWrapper,
  ScrollLabelWithArrow,
  ScrollContainer,
  ScrollableGrid,
  Grid,
  ButtonContainer,
  DesktopButtonContainer,
  MobileButtonContainer,
  DateText,
} from "./styles"

const defaultComponentTheme = (oldTheme) => {
  if (oldTheme.component) return oldTheme
  return {
    ...oldTheme,
    component: {
      background: "initial",
      text: oldTheme.colors.text.primary,
      sectionHeading: oldTheme.contentfulTemplates.Standard.sectionHeading,
    },
  }
}

const GridComponent = ({
  id,
  elRef,
  className,
  children,
  preHeading,
  title,
  useMonoline,
  subtitle,
  logo,
  logoAspectRatio,
  body,
  mobileHorizontal,
  mobileItemCount,
  numColumns = { default: 4, desktopL: 3, hamburgerLarge: 3, desktop: 3, tablet: 2, mobile: 1 },
  filterSort = null,
  buttonElement,
  buttonPosition,
  dataId,
  hideOnPageLoad,
  textComponent,
  mobileNoBorder,
  useHeadingLine,
  useSlimTitle,
  showDescriptionOnMobile,
  useHorizontalScrollOnMobile,
  hideText,
  isScrollable,
  items,
  isNested,
  enforceMarginDecrease,
  isNavigation,
  isFocusLayout,
  leftFocus,
  isFocusedItem,
  isRailItem,
  parentLayout,
  currentDate,
  isRightRail,
  ...props
}) => {
  const hasTopButton = Boolean(buttonElement) && buttonPosition === "Top"
  const hasBody = Boolean(body)

  const renderGrid = () =>
    isScrollable ? (
      <ScrollableGridComponent
        items={items}
        pageType="Landing"
        mobileItemCount={mobileItemCount}
        isScrollable={isScrollable}
        {...props}
      />
    ) : (
      <Grid
        {...props}
        mobileItemCount={mobileItemCount}
        numColumns={numColumns}
        mobileHorizontal={mobileHorizontal}
        isNested={isNested}
        isRightRail={isRightRail}
        isRailItem={isRailItem}
      >
        {children}
      </Grid>
    )

  const buildDate = currentDate
    ? new Date(currentDate).toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : null

  return (
    <ThemeProvider theme={defaultComponentTheme}>
      <Container
        hideOnPageLoad={hideOnPageLoad}
        data-exp-id={dataId}
        id={id}
        ref={elRef}
        className={className}
        textComponent={textComponent}
        isNested={isNested}
        enforceMarginDecrease={enforceMarginDecrease}
        useHorizontalScrollOnMobile={useHorizontalScrollOnMobile}
        isFocusLayout={isFocusLayout}
        leftFocus={leftFocus}
        isFocusedItem={isFocusedItem}
        isRailItem={isRailItem}
        parentLayout={parentLayout}
      >
        {!hideText && preHeading && <PreHeading dangerouslySetInnerHTML={{ __html: preHeading }} />}
        {currentDate && <DateText>{buildDate}</DateText>}
        <HeadingRow
          hasTopButton={hasTopButton}
          hasBody={hasBody}
          isNested={isNested}
          isRailItem={isRailItem}
          hideText={hideText}
        >
          {!hideText && (
            <SectionHeading
              title={title}
              subtitle={subtitle}
              logo={logo}
              logoAspectRatio={logoAspectRatio}
              useMonoline={useMonoline}
              textComponent={textComponent}
              mobileNoBorder={mobileNoBorder}
              useLine={useHeadingLine || isNested}
              useSlimTitle={useSlimTitle || isNested}
              showDescriptionOnMobile={showDescriptionOnMobile}
              hasBody={hasBody}
              isNested={isNested}
              isScrollable={isScrollable}
              buttonElement={buttonElement}
              hasTopButton={hasTopButton}
              hideHeadlineOnMobile={isRailItem}
              isFocusedItem={isFocusedItem}
              isRailItem={isRailItem}
            />
          )}
          {isNavigation && hasTopButton && <ButtonContainer>{buttonElement}</ButtonContainer>}
          {!hideText && body && <Body dangerouslySetInnerHTML={{ __html: body }} />}
        </HeadingRow>
        {buttonElement && buttonPosition !== "Top" && (
          // IsRoutine prop is not ideal, but it's a temporary solution
          <DesktopButtonContainer bottom isRoutine={isScrollable && buttonPosition === "Bottom"}>
            {buttonElement}{" "}
          </DesktopButtonContainer>
        )}
        {filterSort}
        <DesktopWrapper>{renderGrid()}</DesktopWrapper>
        <MobileWrapper>
          {/* this logic should be checked cc. Bardh */}
          {isScrollable && useHorizontalScrollOnMobile ? (
            <>
              <ScrollLabelWithArrow
                useLine={useHeadingLine || isNested}
                hideHeadlineOnMobile={isRailItem}
              />
              <ScrollContainer>
                <ScrollableGrid isRailItem={isRailItem}>{children}</ScrollableGrid>
              </ScrollContainer>
            </>
          ) : (
            renderGrid()
          )}
        </MobileWrapper>
        {buttonElement && buttonPosition !== "Top" && (
          // IsRoutine prop is not ideal, but it's a temporary solution
          <MobileButtonContainer bottom isRoutine={isScrollable && buttonPosition === "Bottom"}>
            {buttonElement}{" "}
          </MobileButtonContainer>
        )}
      </Container>
    </ThemeProvider>
  )
}

export default GridComponent
